import { useTranslation } from '@mukil/i18n';
import { Badge } from '@jumpstone/ui-react';
import { reimbursement_label } from './expense_utils';
import { format_month_year } from '../../lib/format';
import type { Reimbursement } from '../../data/types';

/**
 * Static map — keeps every key greppable rather than built at runtime.
 * `reimbursed_via_payroll_pending` is its OWN complete sentence (no `{period}`
 * placeholder) for a real, permanent state: a payroll-method claim with no
 * resolvable period yet, since `payroll.finalisePayRun` isn't OAuth-exposed
 * (#22798) — see `reimbursement_label`'s doc comment in `expense_utils.ts`.
 */
const REIMBURSEMENT_KEY = {
  reimbursed_separately: 'expenses.reimbursed_separately',
  reimbursed_via_payroll: 'expenses.reimbursed_via_payroll',
  reimbursed_via_payroll_pending: 'expenses.reimbursed_via_payroll_pending',
} as const;

/** How a claim is being settled — outside payroll, or folded into a named (or not-yet-swept) pay run. */
export function ReimbursementBadge({
  reimbursement,
}: {
  reimbursement: Reimbursement;
}): React.JSX.Element {
  const { t, locale } = useTranslation('wp');
  const label = reimbursement_label(reimbursement);

  return (
    <Badge
      variant={label.key === 'reimbursed_separately' ? 'neutral' : 'info'}
      className="badge-no-dot"
    >
      {label.period !== undefined
        ? t(REIMBURSEMENT_KEY.reimbursed_via_payroll, {
            period: format_month_year(label.period, locale),
          })
        : t(REIMBURSEMENT_KEY[label.key])}
    </Badge>
  );
}
